import React from "react";

interface RNConfiguredDocumentActionButtonProps {
  label: string;
  title: string;
  disabled: boolean;
  icon: React.ElementType;
  onClick: () => void;
}

const RNConfiguredDocumentActionButton: React.FC<RNConfiguredDocumentActionButtonProps> = ({
  label,
  title,
  disabled,
  icon: Icon,
  onClick,
}) => (
  <span className="inline-flex" title={title}>
    <button
      type="button"
      disabled={disabled}
      aria-label={label}
      onClick={onClick}
      className={`group relative flex items-center gap-1.5 px-2.5 py-1.5 rounded-lg shadow-md transition-all duration-200 focus:outline-none focus:ring-2 text-[11px] font-semibold bg-white ${
        disabled
          ? "border border-gray-300 text-gray-400 cursor-not-allowed"
          : "border-2 border-blue-600 text-blue-600 hover:bg-blue-50 hover:shadow-lg hover:scale-105 focus:ring-blue-500/50"
      }`}
    >
      <Icon size={14} strokeWidth={2.5} />
      {label}
    </button>
  </span>
);

export default RNConfiguredDocumentActionButton;
